import { createTheme } from '@bitstopco/bitstop-theme';

// Create a new theme instance with the default color schema
export default createTheme();
